import { TextField, TextFieldProps } from "@mui/material";
import { useField } from "@unform/core"
import { useEffect, useState } from "react";
import { UtilidadeService } from "../services/api/utilidades/UtilidadesService";

type TVTextFieldProps = TextFieldProps & {
    name: string;
    maxLength?: number ;
    shrink?: boolean;   
}

//Componentes Unform
export const VTextField: React.FC<TVTextFieldProps> = ({ name, maxLength,shrink, ...rest }) => {
    const { fieldName, registerField, defaultValue, error, clearError } = useField(name);
    const [value, setValue] = useState(defaultValue);
   
    useEffect(() => {        
        registerField({
            name: fieldName,
            getValue: () => value,
            setValue: (e, newValue) => setValue(newValue)})
    }, [registerField, fieldName, value])

    return (
        <TextField
            {...rest}
            
            error={!!error}
            helperText={error}
            defaultValue={defaultValue}
            onKeyDown={(e) => { error && clearError(); rest.onKeyDown?.(e); }}
            style={{ fontSize: UtilidadeService.isMobile() ? 14 : 16, height: UtilidadeService.isMobile() ? 35 : "auto" }}
            value={value || ""}
            size={"small" }  
            onChange={(e) => { setValue(e.target.type === "number" ? Number(e.target.value) : e.target.value); rest.onChange?.(e); }}
            slotProps={{
                htmlInput: {
                    maxLength: maxLength 
                },
                inputLabel: {
                    shrink: shrink,
                style: {
                    fontSize: UtilidadeService.isMobile() ? 14 : 16
                }
                }
            }}
        />
    );
};